var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PageHeader", {
        attrs: {
          "left-side-class": "col-xl-4",
          page: _vm.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _vm.userHasPermissions(
                  "visitregistry.visitcertification.download"
                )
                  ? _c("drop-down", {
                      staticClass: "visit-certification-dropdown",
                      attrs: {
                        icon: "fas fa-clipboard",
                        items: _vm.visitCertificationActionItems,
                        title: "Certificaciones de Visitas"
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("FilterManager", {
        ref: "visitRegistryFilterRef",
        attrs: { filters: _vm.fullFiltersConfiguration, "open-advanced": true },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          action: _vm.onChangeActions,
          age: _vm.onChangeAge,
          center: _vm.onChangeCenter,
          location: _vm.onChangeLocation,
          locationsType: _vm.onChangeLocationsType,
          month: _vm.onChangeMonth,
          provider: _vm.onChangeProvider,
          search: _vm.onSearchHandler,
          service: _vm.onChangeService,
          sie: _vm.onChangeSie,
          specialist: _vm.onChangeSpecialist
        },
        model: {
          value: _vm.selectedFilters,
          callback: function($$v) {
            _vm.selectedFilters = $$v
          },
          expression: "selectedFilters"
        }
      }),
      _vm.results != null && _vm.results.length > 0
        ? _c("CustomSeparator", {
            staticClass: "pt-3 my-3",
            attrs: { text: "Resultado de Referido" }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _vm._l(_vm.results, function(item, index) {
            return _c(
              "section",
              { key: "visit-registry" + index },
              [
                _c(
                  "CustomCallout",
                  {
                    staticClass: "mb-3 custom-callout",
                    attrs: {
                      "border-color": _vm.getBorderColor(item),
                      controlled: true,
                      opened: item.isOpen
                    },
                    on: {
                      "click:open": function($event) {
                        return _vm.onToggleAdditionalInfo(item)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        item.isOpen
                          ? {
                              key: "edition",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "bg-secondary-9 p-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "info-panel bg-white rounded"
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-8 col-sm-12"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "info-panel-main-title"
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "fas fa-info-circle"
                                                    }),
                                                    _c("span", [
                                                      _vm._v(
                                                        "Información General"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-3 col-sm-12"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "info-panel-main-title"
                                                  },
                                                  [
                                                    _c("em", {
                                                      staticClass:
                                                        "fas fa-info-circle"
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Visitas")
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ]),
                                          item.isEducativeService
                                            ? _c("educative-additional-info", {
                                                attrs: {
                                                  "assignment-end-date": _vm.dateFormat(
                                                    item.assignmentEndDate
                                                  ),
                                                  "assignment-start-date": _vm.dateFormat(
                                                    item.assignmentStartDate
                                                  ),
                                                  "custom-class": "mt-2 ml-2",
                                                  "show-visit-details": true,
                                                  value:
                                                    item.educationServiceInfo ||
                                                    {},
                                                  "visits-absence":
                                                    item.visitsAbsence,
                                                  "visits-regular":
                                                    item.visitsRegular
                                                }
                                              })
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "info-panel-container"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 col-sm-12 mr-md-5"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-item col-md-3 col-sm-12"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("Modalidad:")
                                                          ]),
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.modality
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-item col-md-3 col-sm-12"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              "Frecuencia:"
                                                            )
                                                          ]),
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.frequency
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-item col-md-3 col-sm-12"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("Duración:")
                                                          ]),
                                                          _c("label", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.duration
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-item col-md-3 col-sm-12"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v("Vigencia:")
                                                          ]),
                                                          _c("label", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.effectiveDateFrom
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  item.effectiveDateTo
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-3 col-sm-12 col-spacing d-flex align-items-start visit-day border-left pl-3 pl-md-3 pl-sm-3 mb-2 pt-0"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex-grow-1 ml-1 ml-md-0 ml-sm-1"
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "color-gray-6 font-14 font-weight-normal"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Dí­as Registrados en Visitas Regulares: "
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex row pl-3 pl-md-3 pl-sm-3"
                                                              },
                                                              _vm._l(
                                                                item.visitsRegular,
                                                                function(
                                                                  visit,
                                                                  j
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: `visit-regular-key-${j}`,
                                                                      staticClass:
                                                                        "bg-secondary-2 visit-day__box rounded col-1 mt-1 mr-1"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "color-black font-14"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                visit.visitDay
                                                                              ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-3"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "color-gray-6 font-14 font-weight-normal"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Dí­as Registrados en Ausencia: "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex row pl-md-3 pl-sm-3"
                                                                },
                                                                _vm._l(
                                                                  item.visitsAbsence,
                                                                  function(
                                                                    visit,
                                                                    j
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        key: `visit-regular-key-${j}`,
                                                                        staticClass:
                                                                          "bg-visit-absence visit-day__box rounded mr-2 col-1 mt-1"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "color-black font-14"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  visit.visitDay
                                                                                ) +
                                                                                " "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            ]
                                                          ),
                                                          !item.isEducativeService
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-3"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "color-gray-6 font-14 font-weight-normal"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Dí­as Registrados en Horas Compensatorias: "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "d-flex pl-md-3 pl-sm-3"
                                                                    },
                                                                    _vm._l(
                                                                      item.visitsCompensatory,
                                                                      function(
                                                                        visit,
                                                                        j
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: `visit-regular-key-${j}`,
                                                                            staticClass:
                                                                              "bg-visit-compensatory visit-day__box rounded mr-2"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "color-black font-14"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      visit.visitDay
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                          _vm.selectedFilters
                                            .supervisedSpecialist
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "info-panel-container"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info-panel-item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Especialista Supervisado:"
                                                        )
                                                      ]),
                                                      _c("label", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm
                                                                .selectedFilters
                                                                .supervisedSpecialist
                                                                .name
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-10" }, [
                        _c("div", { staticClass: "row py-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-3 col-sm-12 mr-md-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Estudiante: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.studentSieId) +
                                      " - " +
                                      _vm._s(item.studentName) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-sm-12 ml-md-5" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Edad: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [_vm._v(" " + _vm._s(item.studentAge) + " ")]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 col-sm-12 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Servicio: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.disciplineName) + " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 col-sm-12 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Tipo de Lugar: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.locationTypeName) + " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-2 col-sm-12 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-gray-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Lugar de Servicio: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "font-weight-normal text-black"
                                },
                                [_vm._v(" " + _vm._s(item.locationName) + " ")]
                              )
                            ]
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-md-2 col-sm-12 col-spacing row align-items-start justify-content-end"
                        },
                        [
                          _c("ActionButton", {
                            staticClass: "ml-4 px-4",
                            attrs: {
                              i: "fas fa-file-import",
                              text: "Entrar",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onEnterHandler(item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm.showErrorContainer(item)
                  ? _c(
                      "div",
                      { staticClass: "bg-secondary-19 p-2 rounded mt-n3 mb-3" },
                      [
                        item.errors
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                              },
                              [
                                _c("em", {
                                  staticClass:
                                    "fas fa-exclamation-circle pl-2 ml-1 color-primary-4"
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-2 no-eligible-message pl-1 color-secondary-20"
                                  },
                                  [
                                    _vm._v(
                                      " (" + _vm._s(item.errors) + ") Error "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.isPeiNotSigned(item)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-21 font-14 font-weight-normal d-flex align-items-center"
                              },
                              [
                                _c("em", {
                                  staticClass:
                                    "fas fa-file-invoice pl-2 ml-1 color-primary-4"
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-2 no-eligible-message pl-2 color-secondary-20"
                                  },
                                  [
                                    _vm._v(
                                      " No cuenta con un PEI del año corriente firmado en sistema. "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _vm.results != null && _vm.results.length === 0
            ? _c("custom-result-not-found")
            : _vm._e()
        ],
        2
      ),
      _vm.results != null && _vm.results.length > 0
        ? _c("Pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }